import { useState } from 'react';

import MeetApprovedRequestData from './MeetApprovedRequestData';

const UseMeetApprovedRequestData = () => {
  const [meetApprovedRequestState, setMeetApprovedRequestState] = useState(MeetApprovedRequestData.INITIAL_STATE);

  const getMeetApprovedRequest = (isRevisit) => {
    MeetApprovedRequestData.getMeetApprovedRequest(meetApprovedRequestState, setMeetApprovedRequestState, isRevisit);
  };

  const getApprovedMeetWorkflow = (workflowId) => {
    MeetApprovedRequestData.getApprovedMeetWorkflow(workflowId, meetApprovedRequestState, setMeetApprovedRequestState);
  };

  const putApprovedMeetWorkflow = (workflowId, workflowObj) => {
    MeetApprovedRequestData.putApprovedMeetWorkflow(workflowId, workflowObj, meetApprovedRequestState, setMeetApprovedRequestState);
  };

  const clearObjData = () => {
    setMeetApprovedRequestState({
      ...meetApprovedRequestState,
      isObjLoading: false,
      isObjLoaded: false,
      isSaving: false,
      isSaved: false,
      objData: {}
    });
  };

  const clearArrayData = () => {
    setMeetApprovedRequestState({
      ...meetApprovedRequestState,
      isArrayLoading: false,
      isArrayLoaded: false,
      isSaving: false,
      isSaved: false,
      arrayData: []
    });
  };

  const confirmSave = () => {
    setMeetApprovedRequestState({
      ...meetApprovedRequestState,
      isSaved: false
    });
  };

  return {
    meetApprovedRequestState,
    clearArrayData,
    clearObjData,
    confirmSave,
    getMeetApprovedRequest,
    getApprovedMeetWorkflow,
    putApprovedMeetWorkflow
  };
};

export default UseMeetApprovedRequestData;